<div class="hero-media">
    <finder-picture
        [picture]="picture" class="fit"
        [loadingType]="loadingType"
    ></finder-picture>
</div>
